@use '~/theme/theme' as *;

.anchorIcon {
  margin: 0 6px;
}

.tooltipIcon {
  flex-shrink: 0;
  color: color(violet-600);
}

.tooltipContent {
  max-width: 300px;
}
